import React from 'react'
import {createRoot} from 'react-dom/client';
import ReferralPortal from '../components/ReferralPortal';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(<ReferralPortal />);

